import React from 'react';
import PropTypes from 'prop-types';

const ClockIn = ({ startTimer, cancel }) => {
  return (
    <div>
      <button
        onClick={startTimer}
        className="c-btn u-width-120"
      >
        Clock In
      </button>
      <button
        className="c-btn c-btn--grey u-width-120 u-ml"
        onClick={cancel}
      >
        Cancel
      </button>
    </div>
  );
};

ClockIn.propTypes = {
  startTimer: PropTypes.func.isRequired,
  cancel: PropTypes.func.isRequired,
};

export default ClockIn;
